interface RunProjectCreateSubmitCallbacks {
  onSuccess: () => void;
  onFailure: () => void;
}

// Mirror of runTaskCreateSubmit (see taskCreateBottomSheetSubmit.ts): the
// success-only cleanup (resetForm, clear members/attachments) must not run
// when the submit rejects, or a project that was never created still wipes
// the user's input. ProjectFormStack rejects when its pre-flight team
// refetch fails (e.g. offline), so onFailure is what clears the submit lock
// and lets the user retry from the filled-in form.
//
// The rejection handler is passed as submitForm().then(onSuccess, onFailure)
// rather than a trailing .catch() — a trailing .catch() would also swallow
// an error thrown from inside onSuccess itself (e.g. a bug in the reset
// logic), silently masking it as if the create had failed.
export const runProjectCreateSubmit = (
  submitForm: () => Promise<unknown>,
  { onSuccess, onFailure }: RunProjectCreateSubmitCallbacks
) => submitForm().then(onSuccess, onFailure);
